declare global {
	interface Scheduler {
		yield: () => Promise<void>
	}

	interface Window {
		scheduler?: Scheduler
	}
}

export function yieldToMain() {
	if (window.scheduler) {
		return window.scheduler.yield()
	}

	// Fall back to yielding with setTimeout.
	return new Promise((resolve) => {
		setTimeout(resolve, 0)
	})
}
